import React from 'react';
import './loading_icon.scss';

function LoadingIcon(props) {
  return (
    <div className={`loading-icon${props.className ? ` ${props.className}` : ''}`}>

      <p className="loading-icon__text">{props.text || 'Carregando'}</p>
      <div className="loading-icon__icon-2">

        <svg
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid slice"
        >
          <path
            stroke="#9dbea7" 
            strokeLinecap="round"
            fill="#9dbea7"
            d="M 5 69 A 50 54, 0, 0, 0, 95 69 A 50 47, 0, 0, 1, 5 69 Z"
          />
        </svg>

      </div>
      <div className="loading-icon__icon-1">

        <svg
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid slice"
        >
          <path
            stroke="#193E0A" 
            strokeLinecap="round"
            fill="#193E0A"
            d="M 5 31 A 50 51, 0, 0, 1, 95 31 A 50 46, 0, 0, 0, 5 31 Z"
          />
        </svg>

      </div>

    </div>
  );
}

export default LoadingIcon;
